export default __webpack_public_path__ + "static/media/minun-hoitoni.62a6e30d.svg";